import { render, staticRenderFns } from "./UserResource.vue?vue&type=template&id=2c97487b&"
import script from "./UserResource.vue?vue&type=script&lang=js&"
export * from "./UserResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports